import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchUserTypeApi from "@/redux/slice/auth/apis/fetchUserType";
import { FetchUserTypePayload } from "@/redux/slice/auth/types/FetchUserTypePayload";

export default createAsyncThunk("auth/fetchUserType", async (payload: FetchUserTypePayload) => {
  const fetchUserTypeResponse = await fetchUserTypeApi(payload);

  return fetchUserTypeResponse?.data?.getUserProfileType?.profile;
});
